import TCGplayerLogoRow1x from '../images/partner/tcgplayer-row-black@1x.png'
import TCGplayerLogoRow2x from '../images/partner/tcgplayer-row-black@2x.png'
import TCGplayerLogoRow3x from '../images/partner/tcgplayer-row-black@3x.png'
import TCGplayerLogoWhite1x from '../images/partner/tcgplayer-row-white@1x.png'
import TCGplayerLogoWhite2x from '../images/partner/tcgplayer-row-white@2x.png'
import TCGplayerLogoWhite3x from '../images/partner/tcgplayer-row-white@3x.png'
import TCGplayerLogoColumn1x from '../images/partner/tcgplayer-column@1x.png'
import TCGplayerLogoColumn2x from '../images/partner/tcgplayer-column@2x.png'
import TCGplayerLogoColumn3x from '../images/partner/tcgplayer-column@3x.png'
import CardmarketLogoRow1x from '../images/partner/cardmarket-row-blue@1x.png'
import CardmarketLogoRow2x from '../images/partner/cardmarket-row-blue@2x.png'
import CardmarketLogoRow3x from '../images/partner/cardmarket-row-blue@3x.png'
import CardmarketLogoWhite1x from '../images/partner/cardmarket-row-white@1x.png'
import CardmarketLogoWhite2x from '../images/partner/cardmarket-row-white@2x.png'
import CardmarketLogoWhite3x from '../images/partner/cardmarket-row-white@3x.png'
import CardmarketLogoColumn1x from '../images/partner/cardmarket-column-blue@1x.png'
import CardmarketLogoColumn2x from '../images/partner/cardmarket-column-blue@2x.png'
import CardmarketLogoColumn3x from '../images/partner/cardmarket-column-blue@3x.png'
import CardmarketLogoColumnWhite1x from '../images/partner/cardmarket-column-white@1x.png'
import CardmarketLogoColumnWhite2x from '../images/partner/cardmarket-column-white@2x.png'
import CardmarketLogoColumnWhite3x from '../images/partner/cardmarket-column-white@3x.png'
import { cardNameLanguageMapping } from '../../config'
import { EUR, USD } from './currencies'

export const TCG_PLAYER = 1
export const CARD_MARKET = 2

export const priceSourceCurrencies = {
	1: USD,
	2: EUR,
	3: EUR,
	4: EUR,
	5: EUR,
	6: EUR,
	7: EUR,
	8: EUR,
	9: USD,
	10: USD,
	11: USD,
	12: USD,
	13: USD
}

export const priceSourceKeys = {
	1: 'tp_default',
	2: 'cm_default',
	3: 'cm_avg',
	4: 'cm_low',
	5: 'cm_trend',
	6: 'cm_avg1',
	7: 'cm_avg7',
	8: 'cm_avg30',
	9: 'tp_low',
	10: 'tp_mid',
	11: 'tp_high',
	12: 'tp_market',
	13: 'tp_direct_low'
}

export const priceSourceParents = {
	1: TCG_PLAYER,
	2: CARD_MARKET,
	3: CARD_MARKET,
	4: CARD_MARKET,
	5: CARD_MARKET,
	6: CARD_MARKET,
	7: CARD_MARKET,
	8: CARD_MARKET,
	9: TCG_PLAYER,
	10: TCG_PLAYER,
	11: TCG_PLAYER,
	12: TCG_PLAYER,
	13: TCG_PLAYER
}

export const priceSourceNames = {
	1: 'Default',
	2: 'Default',
	3: 'AVG',
	4: 'Low',
	5: 'Trend',
	6: 'AVG1',
	7: 'AVG7',
	8: 'AVG30',
	9: 'Low',
	10: 'Mid',
	11: 'High',
	12: 'Market',
	13: 'Direct Low'
}

export const priceSourceColors = {
	1: '#3A86FF',
	2: '#3A86FF',
	3: '#58B09C',
	4: '#A846A0',
	5: '#FC8E42',
	6: '#F2BB41',
	7: '#9B5DE5',
	8: '#ABB8C3',
	9: '#58B09C',
	10: '#A846A0',
	11: '#FC8E42',
	12: '#F2BB41',
	13: '#9B5DE5'
}


const priceSources = {
	[TCG_PLAYER]: {
		name: 'TCGplayer',
		currency: 'USD',
		logo1x: TCGplayerLogoRow1x,
		logo2x: TCGplayerLogoRow2x,
		logo3x: TCGplayerLogoRow3x,
		logoWhite1x: TCGplayerLogoWhite1x,
		logoWhite2x: TCGplayerLogoWhite2x,
		logoWhite3x: TCGplayerLogoWhite3x,
		logoColumn1x: TCGplayerLogoColumn1x,
		logoColumn2x: TCGplayerLogoColumn2x,
		logoColumn3x: TCGplayerLogoColumn3x,
		logoColumnWhite1x: TCGplayerLogoColumn1x,
		logoColumnWhite2x: TCGplayerLogoColumn2x,
		logoColumnWhite3x: TCGplayerLogoColumn3x,
		icon: 'currency-dollar',
		affiliate: true,
		color: 'tcgplayer',
		buildLink: (externalLink) => {
			if (!externalLink) return null

			return `https://partner.tcgplayer.com/o4yWqb?u=${encodeURIComponent(`https://www.tcgplayer.com${externalLink}`)}`
		}
	},
	[CARD_MARKET]: {
		name: 'Cardmarket',
		currency: 'EUR',
		icon: 'currency-euro',
		logo1x: CardmarketLogoRow1x,
		logo2x: CardmarketLogoRow2x,
		logo3x: CardmarketLogoRow3x,
		logoWhite1x: CardmarketLogoWhite1x,
		logoWhite2x: CardmarketLogoWhite2x,
		logoWhite3x: CardmarketLogoWhite3x,
		logoColumn1x: CardmarketLogoColumn1x,
		logoColumn2x: CardmarketLogoColumn2x,
		logoColumn3x: CardmarketLogoColumn3x,
		logoColumnWhite1x: CardmarketLogoColumnWhite1x,
		logoColumnWhite2x: CardmarketLogoColumnWhite2x,
		logoColumnWhite3x: CardmarketLogoColumnWhite3x,
		affiliate: true,
		color: 'cardmarket',
		buildLink: (externalLink, userLanguage, settings = null) => {
			if (!externalLink) return null

			const language = cardNameLanguageMapping[userLanguage]
			const cardmarketLanguage = ['en', 'de', 'fr', 'it', 'es'].find(item => item === language) ? language : 'en'

			let filterParams = ''

			if (settings && externalLink !== '/YuGiOh/Wants') {
				const filterSellerCountries = settings['site.cardmarketSellerCountries']
				const filterSellerType = settings['site.cardmarketSellerType']
				const filterSellerReputation = settings['site.cardmarketSellerReputation']
				const filterLanguage = settings['site.cardmarketLanguage']
				const filterMinCondition = settings['site.cardmarketMinCondition']
				const filterFirstEdition = settings['site.cardmarketFirstEdition']

				if (filterSellerCountries && Array.isArray(filterSellerCountries) && filterSellerCountries.length > 0) {
					filterParams += `&sellerCountry=${filterSellerCountries.toString()}`
				}

				if (filterSellerType && Array.isArray(filterSellerType) && filterSellerType.length > 0) {
					filterParams += `&sellerType=${filterSellerType.toString()}`
				}

				if (filterSellerReputation && Number(filterSellerReputation) !== 5) {
					filterParams += `&sellerReputation=${filterSellerReputation}`
				}

				if (filterLanguage && Array.isArray(filterLanguage) && filterLanguage.length > 0) {
					filterParams += `&language=${filterLanguage.toString()}`
				}

				if (filterMinCondition && Number(filterMinCondition) !== 7) {
					filterParams += `&minCondition=${filterMinCondition}`
				}

				if (filterFirstEdition && filterFirstEdition !== 'any') {
					filterParams += `&isFirstEd=${filterFirstEdition}`
				}
			}

			return `https://www.cardmarket.com/${cardmarketLanguage}${externalLink}?utm_source=cardcluster&utm_medium=text&utm_campaign=card_prices${filterParams}`
		}
	}
}

export const cardmarketOptions = [
	{
		value: 2,
		label: 'Default',
	},
	{
		value: 3,
		label: 'AVG',
	},
	{
		value: 4,
		label: 'Low',
	},
	{
		value: 5,
		label: 'Trend',
	},
	{
		value: 6,
		label: 'AVG1',
	},
	{
		value: 7,
		label: 'AVG7',
	},
	{
		value: 8,
		label: 'AVG30',
	}
]

export const tcgPlayerOptions = [
	{
		value: 1,
		label: 'Default',
	},
	{
		value: 9,
		label: 'Low',
	},
	{
		value: 10,
		label: 'Mid',
	},
	{
		value: 11,
		label: 'High',
	},
	{
		value: 12,
		label: 'Market',
	},
	{
		value: 13,
		label: 'Direct Low',
	}
]

export default priceSources
